import type { TFunction } from "i18next";
import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import type { BulkAction } from "./personView.actions";

interface ResolveBulkActionModalCopyParams {
  action: BulkAction | null;
  translate: TFunction;
  approveButtonStyles: Partial<BaseButtonStyle>;
  denyButtonStyles: Partial<BaseButtonStyle>;
}

interface BulkActionModalCopy {
  title: string;
  confirmLabel: string;
  confirmStyleOverrides: Partial<BaseButtonStyle> | undefined;
}

/** Builds bulk action modal text and button styling for the selected action. */
export const resolveBulkActionModalCopy = (
  params: ResolveBulkActionModalCopyParams,
): BulkActionModalCopy | null => {
  if (!params.action || params.action === "absence") return null;

  if (params.action === "retract") {
    return {
      title: params.translate("TimeReports.Retract"),
      confirmLabel: params.translate("TimeReports.Retract"),
      confirmStyleOverrides: params.denyButtonStyles,
    };
  }

  if (params.action === "reset") {
    return {
      title: params.translate("General.Reset"),
      confirmLabel: params.translate("General.Reset"),
      confirmStyleOverrides: undefined,
    };
  }

  if (params.action === "reject") {
    return {
      title: params.translate("CompanyTimeReport.Reject"),
      confirmLabel: params.translate("CompanyTimeReport.Reject"),
      confirmStyleOverrides: params.denyButtonStyles,
    };
  }

  return {
    title: params.translate("CompanyTimeReport.Approve"),
    confirmLabel: params.translate("CompanyTimeReport.Approve"),
    confirmStyleOverrides: params.approveButtonStyles,
  };
};
